import bugsnag from './bugsnag';
import { INotifyOpts } from '@bugsnag/browser/dist/types/bugsnag-core/common';

export function reportError(err: any, options: INotifyOpts) {
    //bugsnag.notify(err, options);
    //console.error(err);
}
